import { messstellenFilter } from './messstellenTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../../app/store';
import { messstelle } from "../../utils/apiTypes";
import { getWithAuth } from '../../utils/api';
import { logError } from "../../utils/utils";
import { errorHandler } from '../../utils/errorHandling';

const initialState: messstellenFilter = {
    messstellenListe: Array<messstelle>(),
    messstelleWert: Array<messstelle>(),
    messstelleWertTemp: Array<messstelle>(),
    messstelleWertVorher: Array<messstelle>(),
    messstelleSelectInputValue: "",
    selectedGroups: [],
    openGroups: [],
    loadingMesswerte: false,
    slider: [-0.1, 1.0],
    sliderTemp: [-0.1, 1.0],
    sliderVorher: [-0.1, 1.0],
    isChanged: false,
}

const messstellenFilterSlice = createSlice({
    name: "messstellenFilter",
    initialState,
    reducers: {
        setMessstelleWertTemp: (state, action: PayloadAction<Array<messstelle>>) => {
            state.messstelleWertTemp = action.payload;
            
        },
        setMessstelleWert: (state) => {
            state.messstelleWertVorher = state.messstelleWertTemp;
            state.messstelleWert = state.messstelleWertTemp;
        },
        resetMessstelleWert: (state) => {
            state.messstelleWertTemp = state.messstelleWertVorher;
            state.messstelleWert = state.messstelleWertVorher;
        },
        setMessstellen: (state, action: PayloadAction<messstelle[]>) => {
            state.messstellenListe = action.payload;
        },
        setAllMessstellenAktuellerWert: (state) => {
            state.messstelleWertTemp = state.messstellenListe;
        },
        setMessstelleSelectInputValue: (state, action: PayloadAction<string>) => {
            state.messstelleSelectInputValue = action.payload;
        },
        setSelectedGroups: (state, action: PayloadAction<string[]>) => {
            state.selectedGroups = action.payload;
        },
        setOpenGroups: (state, action: PayloadAction<string[]>) => {
            state.openGroups = action.payload;
        },
        selectFilteredMessstellenOfGroup: (state, action: PayloadAction<{ groups: Array<string> | null, filter: string }>) => {
            const filter = action.payload.filter.toLowerCase();
            if (action.payload.groups) {
                const grouplessMessstellen = state.messstelleWertTemp.filter(x => !action.payload.groups?.includes(x.umspannwerk))
                    .filter(x => state.messstellenListe.filter(m => m.umspannwerk == x.umspannwerk).length != state.messstelleWertTemp.filter(m => m.umspannwerk == x.umspannwerk).length);
                state.messstelleWertTemp = state.messstellenListe.filter(x => x.umspannwerk ? action.payload.groups?.includes(x.umspannwerk) : false);
                state.messstelleWertTemp = state.messstelleWertTemp.concat(grouplessMessstellen);
                state.messstelleWertTemp = state.messstelleWertTemp.filter(x => x.name.toLowerCase().includes(filter) || x.schaltfeld.toLowerCase().includes(filter) || x.umspannwerk.toLowerCase().includes(filter));
            } else {
                state.messstelleWertTemp = state.messstellenListe.filter(x => x.name.toLowerCase().includes(filter) || x.schaltfeld.toLowerCase().includes(filter) || x.umspannwerk.toLowerCase().includes(filter));
            }
        },
        setSlider: (state) => {
            state.sliderVorher = state.sliderTemp;
            state.slider = state.sliderTemp;
        },
        setSliderTemp: (state, action: PayloadAction<number[]>) => {
            state.sliderTemp = action.payload;
        },
        resetSlider: (state) => {
            state.sliderTemp = state.sliderVorher;
            state.slider = state.sliderVorher;
        },
        setMesswerteLoading: (state, action: PayloadAction<boolean>) => {
            state.loadingMesswerte = action.payload;
        },
        setIsChangedMessstelle: (state, action: PayloadAction<boolean>) => {
            state.isChanged = action.payload;
        },
    }
});

export const {
    setMessstelleWert,
    resetMessstelleWert,
    setMessstelleWertTemp,
    setMesswerteLoading,
    setMessstellen,
    selectFilteredMessstellenOfGroup,
    setAllMessstellenAktuellerWert,
    setSlider,
    setSliderTemp,
    resetSlider,
    setIsChangedMessstelle,
    setSelectedGroups,
    setOpenGroups,
    setMessstelleSelectInputValue
} = messstellenFilterSlice.actions

//Selectors
export const selectMessstelleWert = (state: RootState): messstelle[] => state.messstellenFilter.messstelleWert;
export const selectMessstelleWertTemp = (state: RootState): messstelle[] => state.messstellenFilter.messstelleWertTemp;
export const selectMessstellen = (state: RootState): messstelle[] => state.messstellenFilter.messstellenListe;
export const selectMessstelleSelectInputValue = (state: RootState): string => state.messstellenFilter.messstelleSelectInputValue;
export const selectSelectedGroups = (state: RootState): string[] => state.messstellenFilter.selectedGroups;
export const selectopenGroups = (state: RootState): string[] => state.messstellenFilter.openGroups;
export const selectMesswertLoading = (state: RootState): boolean => state.messstellenFilter.loadingMesswerte;
export const selectSlider = (state: RootState): number[] => state.messstellenFilter.slider;
export const selectSliderTemp = (state: RootState): number[] => state.messstellenFilter.sliderTemp;
export const selectIsChangedMessstelle = (state: RootState): boolean => state.messstellenFilter.isChanged;

export const getMessstellen = () => (
    dispatch: AppDispatch
): void => {
    dispatch(setMesswerteLoading(true));
    getWithAuth("MESSSTELLE", {}).then((response: messstelle[]) => {
        const messstelleHatDaten: messstelle[] = response.filter((e) => e.hatDaten);
        dispatch(setMessstellen(messstelleHatDaten));

    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMesswerteLoading(false)));
}


export default messstellenFilterSlice.reducer